import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "convertible"
const ConvertibleIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12.204 9.239C12.28 8.937 12.584 8.754 12.886 8.829L12.888 8.83H12.893Q12.898 8.834 12.907 8.835L12.962 8.85 13.152 8.902C13.312 8.948 13.533 9.016 13.78 9.102 14.256 9.268 14.889 9.526 15.338 9.862 15.77 10.189 16.182 10.655 16.47 11.017 16.599 11.176 16.708 11.323 16.79 11.438H16.94L17.002 11.452 21.295 12.442C21.891 12.58 22.312 13.111 22.312 13.722V15.75C22.313 16.475 21.726 17.063 21 17.063H19.702C19.325 18.049 18.37 18.75 17.25 18.75 16.13 18.75 15.175 18.05 14.798 17.063H9.578C9.2 18.049 8.243 18.75 7.124 18.75 5.832 18.75 4.759 17.815 4.541 16.585L2.847 16.386C2.186 16.31 1.687 15.748 1.687 15.083V12.98C1.688 12.363 2.12 11.828 2.726 11.698L7.532 10.668 7.678 10.716 9.563 11.344V10.5C9.563 10.19 9.814 9.937 10.125 9.937 10.435 9.937 10.688 10.19 10.688 10.5V11.438H15.358C15.136 11.183 14.892 10.935 14.661 10.762 14.361 10.536 13.87 10.325 13.408 10.164 13.186 10.086 12.985 10.024 12.84 9.983L12.67 9.935 12.627 9.925 12.616 9.92H12.614C12.312 9.845 12.129 9.54 12.204 9.239M7.125 15C6.504 15 6 15.504 6 16.125S6.504 17.25 7.125 17.25 8.25 16.746 8.25 16.125 7.746 15 7.125 15M17.25 15C16.629 15 16.125 15.504 16.125 16.125S16.629 17.25 17.25 17.25 18.375 16.746 18.375 16.125 17.871 15 17.25 15M2.96 12.798C2.874 12.817 2.813 12.893 2.813 12.981V13.313H3.375C3.685 13.313 3.937 13.564 3.938 13.875 3.938 14.185 3.686 14.438 3.375 14.438H2.813V15.083C2.813 15.178 2.883 15.258 2.978 15.27L4.586 15.458C4.88 14.33 5.906 13.5 7.125 13.5 8.512 13.5 9.645 14.575 9.742 15.938H14.633C14.73 14.575 15.863 13.5 17.25 13.5S19.77 14.575 19.867 15.938H21C21.104 15.938 21.188 15.853 21.188 15.75V15.188H21C20.69 15.188 20.438 14.936 20.438 14.625S20.689 14.063 21 14.063H21.188V13.722C21.188 13.635 21.128 13.559 21.043 13.539L16.812 12.563H9.658L9.572 12.533 7.467 11.834z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default ConvertibleIcon
